module.exports = __webpack_public_path__ + "static/media/fi-rr-duplicate-white.23f74581.svg";